import FormFieldProps from '@App/forms/v2/common/form-field'
import { FieldError, FieldErrors } from 'react-hook-form'
import { get } from 'lodash'

const isFieldErrors = (value: any): value is FieldErrors => (value as FieldError).message === undefined

const isFieldError = (value: any): value is FieldError => (value as FieldError).message !== undefined

const getFormError = (formFields: FormFieldProps, errors: FieldErrors): FieldError | undefined => {
    if (formFields.parentObjectName) {
        const parentErrors = get(errors, `${formFields.parentObjectName}.${formFields.name}`)
        if (parentErrors && isFieldError(parentErrors)) {
            return parentErrors
        }
        if (parentErrors && isFieldErrors(parentErrors)) {
            const error = parentErrors[formFields.name]
            if (error && isFieldError(error)) {
                return error
            }
        }
    } else {
        const error = errors[formFields.name]
        if (error && isFieldError(error)) {
            return error
        }
    }
    return undefined
}

export default getFormError
